import './Matrix.scss'
import React from 'react'
import cx from 'classnames'

// Create # grid lines as svg path
const gridLines = (columns, rows) => {
  const box = `M0,0v${rows}h${columns}v${-rows}z`
  // inner lines only: 1 .. n - 1
  const inner = n => Array.from({ length: n - 1 }, (_, i) => i + 1)
  const horizontalLines = inner(columns)
    .map(n => `M${n},0v${rows}`)
    .join('')
  const verticalLines = inner(rows)
    .map(n => `M0,${n}h${columns}`)
    .join('')
  return [box, horizontalLines, verticalLines].join('')
}

const svgFilters = (
  <defs>
    <filter x="-10%" y="-10%" width="120%" height="120%" id="drop-shadow">
      <feGaussianBlur in="SourceAlpha" stdDeviation="0.03" />
      <feOffset dx="0.02" dy="0.02" result="offsetblur" />
      <feFlood floodColor="black" floodOpacity="0.2" result="color" />
      <feComposite in2="offsetblur" operator="in" />
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter x="0" y="0" width="100%" height="100%" id="inner-shadow">
      <feGaussianBlur stdDeviation="0.03" />
      <feOffset dx="0.02" dy="0.02" />
      <feComposite operator="out" in="SourceGraphic" result="inverse" />
      <feFlood floodColor="black" floodOpacity="0.2" result="color" />
      <feComposite operator="in" in="color" in2="inverse" result="shadow" />
    </filter>
  </defs>
)

// SVG matrix grid for GMA matrices
type MatrixProps = React.SVGProps<SVGSVGElement> & {
  grid?: boolean
  columns?: number
  rows?: number | null
}

const Matrix = ({
  grid = false,
  columns = 3,
  rows = null,
  children,
  className,
  ...props
}: MatrixProps) => {
  rows = rows || Math.ceil(React.Children.count(children) / columns)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox={`0 0 ${columns} ${rows}`}
      className={cx('Matrix', className)}
      {...props}
    >
      {svgFilters}
      {grid && (
        <path
          className="matrixgrid"
          fill="none"
          stroke="currentColor"
          d={gridLines(columns, rows)}
        />
      )}
      {React.Children.toArray(children).map((child, idx) => (
        <svg
          width={1}
          height={1}
          key={idx}
          x={idx % columns}
          y={Math.floor(idx / columns)}
        >
          {child}
        </svg>
      ))}
    </svg>
  )
}

export default Matrix
